"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.truncateString = void 0;

/**
 * Truncates a string with an elipsis
 * @param  {string}  string String to be shortened with an ellipses at the end if its too long
 * @param  {number}  length Number of characters to allow before truncation
 */
var truncateString = function truncateString(string, length) {
  if (string.length > length) {
    return "".concat(string.slice(0, length), "...");
  }

  return string;
};

exports.truncateString = truncateString;
//# sourceMappingURL=truncate-string.js.map